<template>
    <div class="projet-geltram">
        <div class="back-button" @click="$router.push('/projets')">
            <i class="fas fa-arrow-left"></i> Retour
        </div>
        <div class="projet-header">
            <div class="header-content">
                <img src="@/assets/logo_geltram.png" alt="Logo GELTRAM" class="projet-logo">
                <div class="header-text">
                    <h1>Projet GELTRAM</h1>
                    <div class="projet-meta">
                        <span class="date">Janvier 2025</span>
                        <span class="category educational">Projet Scolaire</span>
                    </div>
                    <div class="competences-badges">
                        <span class="competence-badge">Gérer le patrimoine informatique</span>
                        <span class="competence-badge">Répondre aux incidents et aux demandes d'assistance et d'évolution</span>
                        <span class="competence-badge">Développer la présence en ligne de l'organisation</span>
                        <span class="competence-badge">Travailler en mode projet</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="projet-content">
            <section class="projet-section">
                <h2>Présentation du projet</h2>
                <p>
                    Le projet GELTRAM est un projet d'Atelier Professionnel réalisé au cours du second semestre de mon
                    BTS SIO option SISR.
                    L'objectif était de concevoir et mettre en place l'infrastructure réseau complète d'une entreprise
                    fictive,
                    en combinant des solutions virtualisées sur Proxmox avec des équipements physiques Cisco.
                </p>
            </section>

            <section class="projet-section">
                <h2>Infrastructure déployée</h2>
                <div class="infrastructure-grid">
                    <div class="infra-item">
                        <h3>Services Windows</h3>
                        <ul>
                            <li><strong>Active Directory</strong> : Gestion centralisée des utilisateurs et des
                                ressources</li>
                            <li><strong>WSUS</strong> : Déploiement et gestion des mises à jour Windows</li>
                            <li><strong>IPAM</strong> : Gestion des adresses IP</li>
                        </ul>
                    </div>
                    <div class="infra-item">
                        <h3>Gestion de parc</h3>
                        <ul>
                            <li><strong>GLPI</strong> : Inventaire et gestion des tickets</li>
                            <li><strong>FOG</strong> : Déploiement d'images système</li>
                        </ul>
                    </div>
                    <div class="infra-item">
                        <h3>Sécurité et Réseau</h3>
                        <ul>
                            <li><strong>pfSense</strong> : Pare-feu et routage</li>
                            <li><strong>DMZ</strong> : Zone démilitarisée pour les services exposés</li>
                            <li><strong>VLANs</strong> : Segmentation du réseau</li>
                        </ul>
                    </div>
                    <div class="infra-item">
                        <h3>Serveurs et Conteneurisation</h3>
                        <ul>
                            <li><strong>Apache2</strong> : Serveur web pour les applications internes</li>
                            <li><strong>Docker</strong> : Déploiement de services conteneurisés</li>
                            <li><strong>NAS/SAN</strong> : Stockage centralisé</li>
                            <li><strong>Proxmox Backup Server</strong> : Solution de sauvegarde des VMs</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="projet-section">
                <h2>Architecture réseau</h2>
                <div class="architecture-diagram">
                    <img src="@/assets/Schema_GELTRAM.jpg" alt="Schéma d'architecture réseau du projet GELTRAM"
                        class="schema-image">
                </div>
                <p>
                    L'architecture réseau a été conçue pour répondre aux besoins d'une entreprise moderne,
                    avec une séparation claire entre les différents services et une sécurisation adaptée.
                    Les équipements Cisco (switches et routeurs) ont été configurés pour assurer
                    la connectivité entre les différents segments du réseau.
                </p>
            </section>

            <section class="projet-section">
                <h2>Compétences développées</h2>
                <div class="skills-grid">
                    <div class="skill-item">
                        <h3>Virtualisation</h3>
                        <p>Maîtrise de Proxmox VE, création et gestion de machines virtuelles, clustering</p>
                    </div>
                    <div class="skill-item">
                        <h3>Administration Windows Server</h3>
                        <p>Configuration d'Active Directory, GPO, WSUS et services associés</p>
                    </div>
                    <div class="skill-item">
                        <h3>Réseau</h3>
                        <p>Configuration de switches et routeurs Cisco, VLANs, routage inter-VLAN</p>
                    </div>
                    <div class="skill-item">
                        <h3>Sécurité</h3>
                        <p>Mise en place de pare-feu, DMZ, règles de filtrage, VPN</p>
                    </div>
                    <div class="skill-item">
                        <h3>Conteneurisation</h3>
                        <p>Déploiement et gestion de services avec Docker, orchestration de conteneurs</p>
                    </div>
                </div>
            </section>

            <section class="projet-section">
                <h2>Conclusion</h2>
                <p>
                    Ce projet m'a permis d'appliquer concrètement les connaissances acquises en cours et de développer
                    des compétences pratiques en administration système et réseau. La mise en place d'une infrastructure
                    complète, de la conception à l'implémentation, a été une expérience enrichissante qui correspond
                    parfaitement à mon orientation professionnelle vers les métiers de l'infrastructure IT.
                </p>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjetGeltram'
}
</script>

<style scoped>
.projet-geltram {
    padding: 2rem;
    min-height: 100vh;
    max-width: 1200px;
    margin: 0 auto;
    color: #e0e0e0;
}

.back-button {
    display: inline-flex;
    align-items: center;
    color: #2196F3;
    font-size: 1.1rem;
    margin-bottom: 2rem;
    cursor: pointer;
    transition: color 0.3s;
}

.back-button:hover {
    color: #64B5F6;
}

.projet-header {
    margin-bottom: 3rem;
    border-bottom: 2px solid #2196F3;
    padding-bottom: 1.5rem;
}

h1 {
    color: #2196F3;
    font-size: 2.8rem;
    margin-bottom: 1rem;
}

.projet-meta {
    display: flex;
    gap: 1.5rem;
    font-size: 1.1rem;
}

.date {
    color: #64B5F6;
}

.category {
    padding: 0.3rem 1rem;
    border-radius: 20px;
    font-weight: 500;
}

.category.educational {
    background-color: rgba(33, 150, 243, 0.1);
    color: #2196F3;
    border: 1px solid #2196F3;
}

.projet-section {
    margin-bottom: 3rem;
}

h2 {
    color: #64B5F6;
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    border-left: 4px solid #2196F3;
    padding-left: 1rem;
}

h3 {
    color: #90CAF9;
    font-size: 1.4rem;
    margin-bottom: 1rem;
}

p {
    line-height: 1.7;
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
    color: #B0BEC5;
}

.infrastructure-grid,
.skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin: 2rem 0;
}

.infra-item,
.skill-item {
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #2196F3;
    border-radius: 8px;
    padding: 1.5rem;
}

ul {
    padding-left: 1.5rem;
}

li {
    margin-bottom: 0.8rem;
    line-height: 1.5;
}

.architecture-diagram {
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #2196F3;
    border-radius: 8px;
    padding: 2rem;
    margin: 2rem 0;
    text-align: center;
}

.schema-image {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
}

.header-content {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.projet-logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #2196F3;
}

.header-text {
    flex: 1;
}

.competences-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1rem;
}

.competence-badge {
    font-size: 0.82rem;
    font-style: italic;
    padding: 0.2rem 0.7rem;
    border-radius: 4px;
    border-left: 2px solid rgba(33, 150, 243, 0.5);
    color: #90CAF9;
    background: rgba(33, 150, 243, 0.1);
}

@media screen and (max-width: 768px) {

    .infrastructure-grid,
    .skills-grid {
        grid-template-columns: 1fr;
    }

    .header-content {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }
    
    .projet-logo {
        width: 60px;
        height: 60px;
    }
}
</style>
